import { createFileRoute, notFound } from "@tanstack/react-router";
import { CATEGORY_PILLARS } from "@/data/category-pillars";
import { CategorySubServicePage, subServiceJsonLd } from "@/components/CategorySubServicePage";
import { hreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const SITE = "https://nyclanguageinstitute.com";
const pillar = CATEGORY_PILLARS.accounting;

export const Route = createFileRoute("/accounting/$service")({
  loader: ({ params }) => {
    const service = pillar.subservices.find((s) => s.slug === params.service);
    if (!service) throw notFound();
    return { service };
  },
  head: ({ loaderData }) => {
    if (!loaderData) return { meta: [{ title: ctaTitle("ไม่พบบริการ", "/accounting/$service", "th")}, { name: "robots", content: "noindex" }] };
    const { service } = loaderData;
    const url = `${SITE}/accounting/${service.slug}`;
    const title = `${service.title} — บริการบัญชี CPA | NYC Accounting`;
    const desc = `${service.summary}. เริ่มต้น ฿${service.priceFromThb?.toLocaleString() || "3,500"} — ${service.turnaround || "รายเดือน"}`;
    return {
      meta: [
        { title: ctaTitle(title, "/accounting/$service", "th") }, { name: "description", content: ctaDesc(desc, "/accounting/$service", "th")},
        { property: "og:title", content: ctaTitle(title, "/accounting/$service", "th")}, { property: "og:description", content: ctaDesc(desc, "/accounting/$service", "th")},
        { property: "og:url", content: url }, { property: "og:type", content: "website" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }, ...hreflangLinks(`/accounting/${service.slug}`)],
      scripts: subServiceJsonLd(pillar, service, url),
    };
  },
  component: RouteComp,
  notFoundComponent: () => <div className="p-10 text-center">ไม่พบบริการนี้</div>,
});

function RouteComp() {
  const { service } = Route.useLoaderData();
  return <CategorySubServicePage pillar={pillar} service={service} parentPath="/accounting" />;
}
